export const NOT_ACCELERATED = { id: 'not_accelerated', label: 'No, non accelerato' };
export const OXYTOCIN = { id: 'oxytocin', label: 'Ossitocina' };
export const AMNIORHEXIS = { id: 'amniorhexis', label: 'Amnioressi' };
export const OXYTOCIN_AND_AMNIORHEXIS = {
  id: 'oxytocin_and_amniorhexis',
  label: 'Ossitocina e Amnioressi',
};
